import Form from '../../form';
import addServices from '../../addServices';
import Vue from "vue";

let app = new Vue({
    el: '#app-crvbooking',

    mounted: function() {
        let vm = this;
        $("#app-crvbooking").on('focusout', function (event) {
            let elemName = event.target.getAttribute('name');
            let elemType = event.target.getAttribute('type');
            if(event.target.classList.contains('error')) {
                event.target.classList.remove('error');
                vm.form.errors.clear(elemName);
            }
            if(elemType == 'text' || event.target.tagName.toLowerCase() == 'textarea') {
                console.log(elemName);
                if (elemName != 'email' && (typeof app.form[elemName] !== 'undefined')) {
                    app.form[elemName] = app.form[elemName].toUpperCase();
                }
            }
        });
    },

    data: {
        form: new Form({
            id: '',
            uid: '',
            airport: '',
            servicetype: '',
            name: '',
            email: '',
            phone: '',
            sixtstate: '',
            sixtcode: '',
            sixtid: '',
            indate: '',
            intime: '',
            handofflocation: '',
            outdate: '',
            outtime: '',
            returnlocation: '',
            carclass: '',
            cartype: '',
            travellerinfo: '',
            crvreturn: false,
            fuel: false,
            remark: '',
            remarkC: '',
            remarks: '',
            baggage: ''

        }),
        saved: false,
        submitting: false,
        state: '',
        editable: true,
        inPast: false,
        showStorno: false,
        inStornoTime: true,
        inServiceTime: true,
        licdataok: true,
        handovers: [],
        disabled: [],
        isAdmin: false,
        isTls: false,
    },
    computed: {
      servicetype() {
          return this.form.servicetype;
      }
    },
    watch: {
        submitting() {
            if(this.submitting) {
                $("#overlay").show();
            } else {
                $("#overlay").hide();
            }
        },
        servicetype() {
            if(this.form.servicetype == '1') {
                this.form.indate = '';
                this.form.intime = '';
                this.form.returnlocation = '';
                this.form.fuel = false;
                this.form.crvreturn = '';
            } else if(this.form.servicetype == '3') {
                this.form.sixtstate = 'neu';
                this.form.sixtcode = '';
                this.form.sixtid = '';
                this.form.outdate = '';
                this.form.outtime = '';
                this.form.handofflocation = '';
                this.form.carclass = '';
                this.form.cartype = '';
                this.form.crvreturn = true;
            }

        }

    },
    components: {

    },
    methods: {
        init(appdata) {
            this.form.init(appdata.formdata);
            this.editable = appdata.editable;
            this.showStorno = appdata.showStorno;
            this.inPast = appdata.inPast;
            this.handovers = appdata.handovers;
            this.inServiceTime = appdata.inServiceTime;
            this.disabled = appdata.disabled;
            this.isAdmin = appdata.isAdmin;
            this.isTls = appdata.isTls;
        },
        onSubmit(event) {
            console.log('onsubmit');
            if(($("input[name=sixtid]").is(":visible")) && ($("input[name=sixtid]").val() == '') && ($("input[name=licdataok]").val()!='yes')) {
                event.preventDefault();
                this.showSixtIdDlg(event);
                return;
            }
            this.form.errors.clear();
            this.submitting = true;
            this.submit();
        },
        submit() {
            console.log('submit');
            this.form.post(document.getElementById('crvbookingform').getAttribute('action'))
                .then(response => {
                    if(response.hasOwnProperty('message')) {
                        swal({
                            type: 'error',
                            title: 'Fehler beim Speichern',
                            html: response.message,
                            confirmButtonText: 'weiter...',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        });
                        this.submitting = false;
                        return false;
                    }
                    this.saved = true;
                    console.log(response.bookingId);
                    swal({
                        type: 'success',
                        title: 'Auftrag gespeichert',
                        text: 'Der Auftrag wurde gespeichert',
                        confirmButtonText: 'weiter...',
                        allowOutsideClick: false,
                        allowEscapeKey: false,

                    }).then((result) => {
                        location.href=response.nextUrl;
                    })
                })
                .catch(
                    error => {
                        console.log(error);
                        this.saved = false;
                        this.submitting = false;
                    }
                )
        },
        storno(url) {
            console.log('storno');
            swal({
                type: 'question',
                title: 'Stornierung',
                text: 'Diesen Auftrag wirklich stornieren? Der Vorgang kann nicht rückgängig gemacht werden.',
                confirmButtonText: 'Stornieren',
                showCancelButton: true,
                cancelButtonText: 'Abbrechen',
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.value) {
                    this.doStorno(url);
                } else {
                    return;
                }
            })
        },
        doStorno(url) {
            this.submitting = true;
            this.form.post(url)
                .then(response => {
                    this.saved = true;
                    swal({
                        type: 'success',
                        title: 'Auftrag storniert',
                        text: 'Der Auftrag wurde storniert',
                        confirmButtonText: 'weiter...',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        location.href = response.nextUrl;
                    })
                })
                .catch(
                    error => {
                        console.log(error);
                        this.submitting = false;
                    }
                )
        },
        gotoSend(url) {
            location.href=url;
        },
        showRemarks(event) {
            swal({
                title: 'Hinweis zum Kunden',
                html: this.form.remarks
            })
        },
        showSixtIdDlg(event) {
            axios.post('/crvservice/sixtiddlg', {uid: $("input[name=uid]").val()}).then((response) => {
                let svcModal = $(response.data);
                svcModal.modal('show');
                svcModal.find("#savelicdata").on("click", function(e) {
                    var data = {
                        _token : $("#formsixtid input[name=_token]").val(),
                        uid: $("#formsixtid input[name=uid]").val(),
                        lic_num: $("#formsixtid input[name=lic_num]").val(),
                        issue_date: $("#formsixtid input[name=issue_date]").val(),
                        issue_city: $("#formsixtid input[name=issue_city]").val(),
                        issue_country: $("#formsixtid input[name=issue_country]").val(),
                        birthdate: $("#formsixtid input[name=birthdate]").val(),
                        iddoc_num: $("#formsixtid input[name=iddoc_num]").val(),
                        iddoc_issue_date: $("#formsixtid input[name=iddoc_issue_date]").val(),
                        iddoc_issue_city: $("#formsixtid input[name=iddoc_issue_city]").val(),
                        iddoc_issue_country: $("#formsixtid input[name=iddoc_issue_country]").val()
                    };

                    axios.post($("#formsixtid").attr("action"), data).then((response) => {
                        if(response.data == 'ok') {
                            //close and set ok
                            $("input[name=licdataok]").val('yes');
                        } else {
                            e.preventDefault();
                            $("#sixtidModal .modal-body").replace(response.data);
                        }
                    });
                });
            });
        }



    }
});

export default app;